import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

import { Box } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { FC, useEffect, useRef } from 'react';
import Selector from '../selector/Selector';
import { numberFormatter } from '../../utils';

ChartJS.register(ArcElement, Tooltip, Legend);

interface Props {
  labels: string[];
  values: number[];
  sum: number;
  allYears: string[] | undefined;
  backgroundColors: string[];
  selectedYear: string | undefined;
  setSelectedYear: (value: string) => void;
}

const DoughnutChart: FC<Props> = observer(props => {
  const {
    labels,
    values,
    selectedYear,
    setSelectedYear,
    allYears,
    sum,
    backgroundColors,
  } = props;

  // Create a ref to hold the current sum value
  const sumRef = useRef<number | null>(null);

  useEffect(() => {
    sumRef.current = sum;
  }, [sum]);

  const chartData = {
    labels,
    datasets: [
      {
        label: 'Ausgaben',
        data: values,
        backgroundColor: backgroundColors,
        borderColor: backgroundColors,
        borderWidth: 1,
      },
    ],
  };

  const textCenter = {
    id: 'textCenter',
    beforeDatasetsDraw(chart: ChartJS) {
      const { ctx } = chart;
      ctx.save();
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';

      // Get the current sum value from the ref
      const currentSum = sumRef.current;

      if (currentSum) {
        ctx.fillText(
          `${numberFormatter(currentSum)} €`,
          chart.getDatasetMeta(0).data[0]?.x,
          chart.getDatasetMeta(0).data[0]?.y,
        );
      }

      ctx.restore();
    },
  };
  if (sum) {
    return (
      <Box
        minHeight={500}
        width={1}
        display="flex"
        flexDirection="column"
        justifyItems="center"
        alignItems="center"
      >
        <Selector
          label="Jahr"
          data={allYears || ['']}
          value={selectedYear || ''}
          setSelectedValue={setSelectedYear}
        />
        <Box
          width={1}
          height={1}
          maxHeight={500}
          display="flex"
          flexDirection="column"
          justifyItems="center"
          alignItems="center"
        >
          <Doughnut data={chartData} plugins={[textCenter]} />
        </Box>
      </Box>
    );
  }
  return null;
});

export default DoughnutChart;
